import "regenerator-runtime/runtime";
// Safari < 15.4 に .at が無く、pdfjs-dist のバンドルが使う。worker 側は pdfWorker.ts で読み込む
import "core-js/actual/array/at";
import "core-js/actual/typed-array/at";
// Sentry は Firebase の初期化より先に立ち上げる（sentryInit.ts の NOTE 参照）。
import "./sentryInit";
import "@/firebase";
import "./index.css";
import "./i18n/config.ts";
import { getLanguage } from "./i18n/config";
import { loadMessages } from "./i18n/t";
import { installChunkReloadHandler } from "@/utils/lazyWithReload";

// デプロイ後の stale chunk（動的 import 失敗）を検知したら最新版を取り直すため
// 自動でフルリロードする。画面遷移のたびにエラー画面へ落ちるのを防ぐ。
installChunkReloadHandler();

// 画面の文言には、選択肢やルート名のようにモジュールの読み込み時に t() で確定する
// ものがある。英語の辞書はアプリ本体（appEntry）より先に読み込み、辞書を取れない
// ときは原文（日本語）のまま起動する。
loadMessages(getLanguage())
  .catch(error => {
    console.error("Failed to load the message catalog", error);
  })
  .then(() => import("./appEntry"));
